// ConfirmationModal.jsx
// Reusable confirmation modal component used by CancelView and UpcomingMeeting

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Yes, Confirm",
  cancelText = "Keep It",
  isLoading = false,
  isDangerous = true,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1000]">
      <div className="bg-white rounded-lg p-6 max-w-2xl shadow-lg">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          {title}
        </h3>
        <div className="text-sm text-gray-600 mb-6 leading-relaxed">
          {message}
        </div>
        <p className="text-xs text-gray-400 mb-6">
          This action cannot be undone.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition disabled:opacity-70"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-white text-sm font-medium transition ${
              isDangerous
                ? "bg-[#C31818] hover:bg-red-700"
                : "bg-blue-600 hover:bg-blue-700"
            } ${isLoading ? "opacity-70 cursor-not-allowed" : "cursor-pointer"}`}
          >
            {isLoading ? "Processing…" : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
